/**
 * quote-new-action.js
 *
 * Gestisce i click sui link/bottoni con [data-quote-new-action]:
 *   1. chiede conferma all'utente (azione distruttiva)
 *   2. POST /cart/clear.js per svuotare il carrello live
 *   3. pulisce le chiavi sessionStorage usate dal quote-manager e l'ambiente attivo
 *   4. redirect su /cart (senza query string)
 *
 * Replica il comportamento di startNewQuote() in quote-manager.js, ma è
 * standalone così può essere usato fuori dalla pagina /cart (es. nel menu
 * "Area B2B" del side-panel account, visibile solo ad agenti/rivenditori).
 *
 * Lo script è idempotente: l'IIFE imposta una guard su window quindi se viene
 * caricato più volte (es. modal + drawer mobile) l'handler resta uno solo.
 */
(function () {
  if (window.__bongioQuoteNewActionInit) return;
  window.__bongioQuoteNewActionInit = true;

  var DEFAULT_CONFIRM = 'Vuoi iniziare un nuovo preventivo? Il carrello e i campi attuali verranno svuotati.';

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-quote-new-action]');
    if (!trigger) return;
    e.preventDefault();

    var msg = trigger.getAttribute('data-confirm-msg') || DEFAULT_CONFIRM;
    if (!window.confirm(msg)) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var base = root.replace(/\/$/, '');

    fetch(base + '/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
      .catch(function () { /* fallback to redirect anyway */ })
      .finally(function () {
        try {
          sessionStorage.removeItem('bconfig:current_quote_id');
          sessionStorage.removeItem('bconfig:current_quote_header');
          sessionStorage.removeItem('bconfig:current_quote_number');
        } catch (err) { /* ignore */ }
        // Ambiente attivo (localStorage, vedi quote-manager.js AMBIENTE_KEY):
        // senza questo reset il nuovo preventivo ereditava la stanza del
        // precedente e i prodotti aggiunti finivano di nuovo sotto quella.
        try { localStorage.removeItem('bongio:ambiente_attivo'); } catch (err) { /* ignore */ }
        window.location.href = base + '/cart';
      });
  });
})();
